import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import { withProps } from 'recompose';
import styled from 'styled-components';
import asRendition from '../../asRendition';
import { monospace } from '../../utils';
import { align, bold, caps } from '../Txt';
var BaseHeading = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-weight: normal;\n\t", "\n\t", ";\n\t", "\n\t", "\n"], ["\n\tfont-weight: normal;\n\t", "\n\t", ";\n\t", "\n\t", "\n"])), align, monospace, caps, bold);
BaseHeading.displayName = 'Heading';
var setDefaultProps = withProps(function (props) {
    return Object.assign({
        fontSize: 4,
        m: 0,
        bold: false,
    }, props);
});
var Factory = function (tag) {
    return asRendition(function (props) {
        return React.createElement(BaseHeading, __assign({ as: tag }, props));
    }, [setDefaultProps]);
};
var Base = Factory();
Base.h1 = Factory('h1');
Base.h1.defaultProps = {
    fontSize: 7,
    m: 0,
};
Base.h2 = Factory('h2');
Base.h2.defaultProps = {
    fontSize: 6,
    m: 0,
};
Base.h3 = Factory('h3');
Base.h3.defaultProps = {
    fontSize: 5,
    m: 0,
};
Base.h4 = Factory('h4');
Base.h4.defaultProps = {
    fontSize: 4,
    m: 0,
    bold: true,
};
Base.h5 = Factory('h5');
Base.h5.defaultProps = {
    fontSize: 3,
    m: 0,
    bold: true,
};
Base.h6 = Factory('h6');
Base.h6.defaultProps = {
    fontSize: 2,
    m: 0,
    bold: true,
};
export var Heading = Base;
var templateObject_1;
